import { createFileRoute } from '@tanstack/react-router'
import { ScenarioEditorPage } from '../../../components/scenarios/ScenarioEditorPage'

export const Route = createFileRoute('/$org/remediation-scenarios/$code')({
  component: ScenarioEditorPage,
})
